import Dashboard from '../../components/Plans/Dashboard.vue'
import Login from '../../components/Plans/Login.vue'

export default [
    {
        path: '/login',
        name: 'plans_login',
        component: Login
    },
    {
        path: '/',
        name: 'plans_home',
        component: Dashboard,
        meta: { requiresAuth: true }
    },
    {
        path: '/projects/:id',
        name: 'plans_project_detail',
        component: () => import('../../components/Plans/ProjectDetail.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/admin',
        name: 'plans_admin',
        component: () => import('../../components/Plans/AdminDashboard.vue'),
        meta: { requiresAuth: true }
    }
]
